import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import styles from './counter.module.css';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = { value: 0 };
  }

  incrementItem = () => {
    let value = this.state.value + 1;
      this.updateValue(value, this.props.label);
  }

  decreaseItem = () => {
    if (this.state.value >= 1) {
      let value = this.state.value - 1;
      this.updateValue(value, this.props.label);
    }
  }

  updateValue = (value, label) => {
    this.setState({ value: value });
    this.props.sendData({
      value: value,
      label: label
    });
  }

  render() {
    return (
      <div className={styles.counter}>
        <span className={styles.decrease} onClick={this.decreaseItem}></span>
        <span className={styles.count}>{ this.props.value }</span>
        <span className={styles.increase} onClick={this.incrementItem}></span>
      </div>
    );
  }
}

export default withRouter(Counter);



// WEBPACK FOOTER //
// ./src/components/Counter/Counter.jsx